import React, { useState, useEffect } from "react";

import PageHeader from "../components/PageHeader";
import Section from "../components/Section";
import Row from "../components/Row";
import Column from "../components/Column";
import SummaryTile from "../components/SummaryTile";
import Button from "../components/Button";
import Modal from "../components/Modal";
import Checkbox from "../components/forms/Checkbox";

import { en, es } from "../languages/langs";
import { api } from "../services/api";
import { getCaptchaToken } from "../services/captcha";
import { useHistory } from "react-router-dom";

const MIN_DESCRIPTION_LETTERS = 40;

const Register = ({ activeLang }) => {
  const lang = { en, es }[activeLang];
  const [submit, setSubmit] = useState(false);
  const [salutation, setSalutation] = useState("Mr.");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [countryId, setCountryId] = useState(0);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [typeOfInstitution, setTypeOfInstitution] = useState("empty");
  const [institutionName, setInstitutionName] = useState("");
  const [institutionWebsite, setInstitutionWebsite] = useState("");
  const [institutionFacebookPage, setInstitutionFacebookPage] = useState("");
  const [hasWebsite, setHasWebsite] = useState(false);
  const [shortZooDesc, setShortZooDesc] = useState("");
  const [interestSections, setInterestSections] = useState([]);
  const [receiveSurplus, setReceiveSurplus] = useState(false);
  const [showingSummary, setShowingSummary] = useState(false);
  const history = useHistory();

  const onInterestChange = (e) => {
    const { checked, id } = e.target;
    setInterestSections((prev) => {
      if (checked) {
        return prev.includes(id) ? prev : [...prev, id];
      } else {
        return prev.filter((section) => section !== id);
      }
    });
  };

  // Ticking "no website or Facebook page" clears both URL fields so a stale
  // half-typed address cannot survive into the payload. The description is
  // deliberately kept, so an accidental untick does not discard typed text.
  const onNoWebsiteChange = (checked) => {
    setHasWebsite(checked);
    if (checked) {
      setInstitutionWebsite("");
      setInstitutionFacebookPage("");
    }
  };

  function feedModal(state) {
    let m = document.getElementById("modal2");
    switch (state) {
      case "close":
        m.style.display = "none";
        break;
      case "open":
        m.style.display = "block";
        break;
      default:
        break;
    }
  }

  const [renderedCountrySelect, setRenderedCountriesSelect] = useState([
    <option value="empty" key="empty">
      Loading countries...
    </option>,
  ]);

  useEffect(() => {
    const getCountries = async () => {
      const response = await api.get("/countries");
      const renderedOptions = response.data.map((country) => {
        return (
          <option key={country.country_code} value={country.id}>
            {activeLang === "en" ? country.name : country.spanish_name}
          </option>
        );
      });
      setRenderedCountriesSelect(renderedOptions);
    };
    getCountries();
  }, [activeLang]);

  function isValidURL(string) {
    var res = string.match(
      /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
    );
    return res !== null;
  }

  function gotoNextRegisterPage(no) {
    let focusedPage = no - 1;

    const country = [
      ...document.getElementById("register-form__country").children,
    ].filter((opt) => opt.selected)[0].value;
    const institution = [
      ...document.getElementById("register-form__institution").children,
    ].filter((opt) => opt.selected)[0].value;
    const website = document
      .getElementById("register-form--website")
      .value.trim();
    const facebookPage = document
      .getElementById("register-form--fbpage")
      .value.trim();

    const fields = [
      ...document
        .getElementById(`register-form__part${focusedPage}`)
        .getElementsByTagName("INPUT"),
    ].map((input) => {
      return {
        type: input.type,
        mandatory: input.classList.contains("register-form__input--mandatory"),
        name: input.id,
        checked: input.checked,
        ref: input,
      };
    });
    if (focusedPage === 1) {
      if (country === "empty") {
        document
          .getElementById("register-form__country")
          .classList.add("register-form__input--has-error");
      } else {
        document
          .getElementById("register-form__country")
          .classList.remove("register-form__input--has-error");
      }
    } else if (focusedPage == 2) {
      if (institution === "empty") {
        document
          .getElementById("register-form__institution")
          .classList.add("register-form__input--has-error");
      } else {
        document
          .getElementById("register-form__institution")
          .classList.remove("register-form__input--has-error");
      }
    }

    const errorFields = fields.filter((field) => {
      if (
        (field.type === "text" || field.type === "password") &&
        field.mandatory &&
        field.ref.value === ""
      ) {
        field.ref.classList.add("register-form__input--has-error");
        return field;
      } else {
        field.ref.classList.remove("register-form__input--has-error");
      }

      if (
        field.type === "email" &&
        field.mandatory &&
        (field.ref.value === "" ||
          !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            field.ref.value
          ))
      ) {
        field.ref.classList.add("register-form__input--has-error");
        return field;
      } else {
        field.ref.classList.remove("register-form__input--has-error");
      }
    });

    if (
      errorFields.length > 0 ||
      (focusedPage === 1 && country === "empty") ||
      (focusedPage === 2 && institution === "empty")
    ) {
      alert(lang["mand_info_missing"]);
      return;
    }
    if (focusedPage === 1) {
      const pfield = fields.find(
        (field) => field.name === "register-form--password"
      );
      const rpfield = fields.find(
        (field) => field.name === "register-form--rpassword"
      );
      if (pfield.ref.value !== rpfield.ref.value) {
        alert(lang["passwd_mismatch"]);
        return;
      }
    } else if (focusedPage === 2) {
      if (
        (website !== "" && !isValidURL(website)) ||
        (facebookPage !== "" && !isValidURL(facebookPage))
      ) {
        alert(lang["website_wrong_url"]);
        return;
      }

      if (website === "" && facebookPage === "" && !hasWebsite) {
        alert(lang["extra_info_required"]);
        return;
      }

      if (hasWebsite) {
        const desc = document.getElementById("shortdesc");
        if (!checkInputForBrevity(shortZooDesc.trim(), MIN_DESCRIPTION_LETTERS)) {
          desc.classList.add("register-form__input--has-error");
          alert(lang["extra_info_warning"]);
          return;
        }
        desc.classList.remove("register-form__input--has-error");
      }
    }

    [...document.getElementsByClassName("register-form__part")].forEach(
      (part) => {
        part.classList.add("inactive");
        part.classList.remove("active");
      }
    );
    [...document.getElementsByClassName("progress-pill")].forEach((pill) =>
      pill.classList.remove("progress-pill--active")
    );
    document.getElementById(`register-form__part${no}`).classList.add("active");
    document
      .getElementById(`register-form__part${no}`)
      .classList.remove("inactive");
    document
      .getElementById(`progress-pill${no}`)
      .classList.add("progress-pill--active");

    let ppill1 = document.getElementById("progress-pill1"),
      mLeft = 0;
    for (let i = 1; i < no; i++) {
      let node = document.getElementById("progress-pill" + i),
        w = node.getBoundingClientRect().width,
        m = parseFloat(getComputedStyle(node).marginRight);
      mLeft += w + m;
    }
    ppill1.style.marginLeft = "-" + mLeft + "px";
  }

  function gotoBackRegisterPage(no) {
    [...document.getElementsByClassName("register-form__part")].forEach(
      (part) => {
        part.classList.add("inactive");
        part.classList.remove("active");
      }
    );
    [...document.getElementsByClassName("progress-pill")].forEach((pill) =>
      pill.classList.remove("progress-pill--active")
    );
    document.getElementById(`register-form__part${no}`).classList.add("active");
    document
      .getElementById(`register-form__part${no}`)
      .classList.remove("inactive");
    document
      .getElementById(`progress-pill${no}`)
      .classList.add("progress-pill--active");

    let ppill1 = document.getElementById("progress-pill1"),
      mLeft = 0;
    for (let i = 1; i < no; i++) {
      let node = document.getElementById("progress-pill" + i),
        w = node.getBoundingClientRect().width,
        m = parseFloat(getComputedStyle(node).marginRight);
      mLeft += w + m;
    }
    ppill1.style.marginLeft = "-" + mLeft + "px";
  }

  // Counts letters wherever they appear, so punctuation, digits and accented
  // characters in a normal sentence do not cut the count short.
  const checkInputForBrevity = (input, minLength = 15) => {
    return (input.match(/\p{L}/gu) || []).length >= minLength;
  };

  async function doSend(captchaToken) {
    if (typeOfInstitution === "empty") {
      alert(lang["institution_type_required"]);
      return;
    }
    if (
      hasWebsite &&
      !checkInputForBrevity(shortZooDesc.trim(), MIN_DESCRIPTION_LETTERS)
    ) {
      alert(lang["extra_info_warning"]);
      return;
    }
    const application = {
      email,
      password,
      first_name: firstName,
      last_name: lastName,
      title: salutation,
      country: countryId,
      organisation: {
        type: typeOfInstitution,
        name: institutionName,
      },
      website: institutionWebsite.trim(),
      facebook_page: institutionFacebookPage.trim(),
      mobile_phone: whatsapp,
      short_description: shortZooDesc.trim(),
      interests: {
        zoo_animals: interestSections.length === 6,
        birds: interestSections.includes("interest-birds"),
        primates: interestSections.includes("interest-primates"),
        small_mammals: interestSections.includes("interest-small-mammals"),
        reptiles: interestSections.includes("interest-reptiles"),
        carnivores: interestSections.includes("interest-carnivores"),
        taxidermy: interestSections.includes("interest-taxidermy"),
      },
      receive_surplus_wanted: receiveSurplus,
    };
    if (captchaToken) {
      application.captcha_token = captchaToken;
    }

    try {
      const response = await api.post("/register", application);
      if (response.data.success === false) {
        alert(response.data.message);
        return;
      }
      setSubmit(true);
      feedModal("open");
    } catch (e) {
      console.log(e);
      feedModal("open");
    }
  }

  async function sendRegistrationForm() {
    // The v3 token is verified server-side; the secret no longer ships in
    // this bundle. A null token (blocked script) still submits.
    const captchaToken = await getCaptchaToken();
    doSend(captchaToken);
  }

  const showSummary = () => {
    setShowingSummary(true);
  };

  return (
    <React.Fragment>
      <PageHeader
        titleKey="Register"
        image="images/tiger-john2.jpg"
        bgPos="60% 50%"
        activeLang={activeLang}
      />
      <Section extraClasses="content-width center">
        <Row extraClasses="mobile-p-left__large mobile-p-right__large">
          {!showingSummary && (
            <Column extraClasses="size__two-of-three m-top__x-large">
              <Row extraClasses="progress-pills">
                <div
                  id="progress-pill1"
                  style={{ marginLeft: 0 }}
                  className="progress-pill m-right__x-large progress-pill--has-next progress-pill--active column row mobile-column--autowidth mobile-float__none"
                >
                  <div className="progress-pill__counter column browngrey-background white-text mobile-column--autowidth">
                    1
                  </div>
                  <div className="progress-pill__text column browngrey-text mobile-column--autowidth">
                    {lang["About you"]}
                  </div>
                </div>
                <div
                  id="progress-pill2"
                  className="progress-pill m-right__x-large progress-pill--has-next column row mobile-column--autowidth mobile-float__none"
                >
                  <div className="progress-pill__counter column browngrey-background white-text mobile-column--autowidth">
                    2
                  </div>
                  <div className="progress-pill__text column browngrey-text mobile-column--autowidth">
                    {lang["About your institution"]}
                  </div>
                </div>
                <div
                  id="progress-pill3"
                  className="progress-pill column row mobile-column--autowidth mobile-float__none"
                >
                  <div className="progress-pill__counter column browngrey-background white-text mobile-column--autowidth">
                    3
                  </div>
                  <div className="progress-pill__text column browngrey-text mobile-column--autowidth">
                    {lang["Details of the interest"]}
                  </div>
                </div>
              </Row>
              <Row extraClasses="m-top__large">
                <Column
                  extraClasses="size__one-of-one register-form"
                  id="register-form"
                >
                  <SummaryTile
                    id="register-form__part1"
                    titleKey="Personal information"
                    extraClasses="m-top__x-large register-form__part p-right__medium p-bottom__large"
                    subTitleKey="About you"
                    buttonOnClick={() => gotoNextRegisterPage(2)}
                    buttonTextKey="Next"
                    activeLang={activeLang}
                  >
                    <div className="summary-tile__content m-top__x-large">
                      <Row>
                        <Column extraClasses="size__two-of-twelve">
                          <select
                            name="register-form__salutation"
                            id="register-form__salutation"
                            className="register-form__salutation select--creme"
                            onChange={(e) => {
                              setSalutation(e.target.value);
                            }}
                            value={salutation}
                          >
                            <option value="Mr.">Mr.</option>
                            <option value="Mrs.">Mrs.</option>
                            <option value="Ms.">Ms.</option>
                            <option value="Dr.">Dr.</option>
                            <option value="Ing.">Ing.</option>
                          </select>
                        </Column>
                        <Column extraClasses="size__five-of-twelve p-left__medium mobile-p-left__none mobile-m-top__medium">
                          <input
                            type="text"
                            className="register-form__input register-form__input--mandatory"
                            placeholder={`${lang["First Name"]}*`}
                            id="register-form--fname"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                          />
                        </Column>
                        <Column extraClasses="column size__five-of-twelve p-left__medium mobile-p-left__none mobile-m-top__medium">
                          <input
                            type="text"
                            className="register-form__input register-form__input--mandatory"
                            placeholder={`${lang["Last Name"]}*`}
                            id="register-form--lname"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                          />
                        </Column>
                      </Row>
                      <Row extraClasses="m-top__medium">
                        <Column extraClasses="size__one-of-two">
                          <select
                            name="register-form__country"
                            id="register-form__country"
                            className="register-form__country select--creme"
                            onChange={(e) => {
                              setCountryId(e.target.value);
                            }}
                            value={countryId}
                          >
                            <option
                              key="empty"
                              value="empty"
                            >{`${lang["Country"]}*`}</option>
                            {renderedCountrySelect}
                          </select>
                        </Column>
                        <Column extraClasses="size__one-of-two p-left__medium mobile-p-left__none mobile-m-top__medium">
                          <input
                            type="email"
                            className="register-form__input register-form__input--mandatory"
                            placeholder={`${lang["Email address"]}*`}
                            id="register-form--email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </Column>
                      </Row>
                      <Row extraClasses="m-top__medium">
                        <Column extraClasses="size__one-of-two">
                          <input
                            type="password"
                            className="register-form__input register-form__input--mandatory"
                            placeholder={`${lang["Create password"]}*`}
                            id="register-form--password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                        </Column>
                        <Column extraClasses="size__one-of-two p-left__medium mobile-p-left__none mobile-m-top__medium">
                          <input
                            type="password"
                            className="register-form__input register-form__input--mandatory"
                            placeholder={`${lang["Repeat Password"]}*`}
                            id="register-form--rpassword"
                          />
                        </Column>
                      </Row>
                      <Row extraClasses="m-top__medium">
                        <Column extraClasses="size__one-of-two">
                          <input
                            type="text"
                            className="register-form__input"
                            placeholder="Whatsapp"
                            id="register-form--whatsapp"
                            value={whatsapp}
                            onChange={(e) => setWhatsapp(e.target.value)}
                          />
                        </Column>
                      </Row>
                      <Row extraClasses="m-top__large"></Row>{" "}
                      {/* Just to space the button down */}
                    </div>
                  </SummaryTile>
                  <SummaryTile
                    id="register-form__part2"
                    titleKey="Corporate information"
                    extraClasses="m-top__x-large register-form__part p-right__medium p-bottom__large"
                    subTitleKey="About your institution"
                    showButton={false}
                    activeLang={activeLang}
                  >
                    <div className="summary-tile__content m-top__x-large">
                      <Row extraClasses="m-top__medium">
                        <Column extraClasses="size__one-of-two">
                          <select
                            name="register-form__institution"
                            id="register-form__institution"
                            className="register-form__institution type select--creme"
                            onChange={(e) => {
                              setTypeOfInstitution(e.target.value);
                            }}
                            value={typeOfInstitution}
                          >
                            <option value="empty">{`${lang["Type of insitution"]}*`}</option>
                            <option value="Z">
                              {lang["Zoo and public facilities"]}
                            </option>
                            <option value="PBF">
                              {lang["Private breeding farm"]}
                            </option>
                            <option value="AS">
                              {lang["Animal supplier"]}
                            </option>
                            <option value="ACON">
                              {lang["Animal consult and vet"]}
                            </option>
                          </select>
                        </Column>
                        <Column extraClasses="size__one-of-two p-left__medium mobile-p-left__none mobile-m-top__medium">
                          <input
                            type="text"
                            className="register-form__input register-form__input--mandatory"
                            placeholder={`${lang["Name of insitution"]}*`}
                            id="register-form--nameofinstitution"
                            value={institutionName}
                            onChange={(e) => setInstitutionName(e.target.value)}
                          />
                        </Column>
                      </Row>
                      <Row>
                        <Column extraClasses="size__one-of-one text--centered text--small">
                          ({lang["In case you are a private person"]})
                        </Column>
                      </Row>
                      <Row extraClasses="m-top__medium">
                        <Column extraClasses="size__one-of-two">
                          <input
                            type="text"
                            className="register-form__input"
                            placeholder={lang["Website"]}
                            id="register-form--website"
                            value={institutionWebsite}
                            disabled={hasWebsite}
                            onChange={(e) =>
                              setInstitutionWebsite(e.target.value)
                            }
                          />
                        </Column>
                        <Column extraClasses="size__one-of-two p-left__medium mobile-p-left__none mobile-m-top__medium">
                          <input
                            type="text"
                            className="register-form__input"
                            placeholder={lang["Facebook page"]}
                            id="register-form--fbpage"
                            value={institutionFacebookPage}
                            disabled={hasWebsite}
                            onChange={(e) =>
                              setInstitutionFacebookPage(e.target.value)
                            }
                          />
                        </Column>
                      </Row>
                      <Row extraClasses="m-top__medium">
                        <Column extraClasses="size__one-of-one">
                          <label htmlFor="no-website">
                            <input
                              type="checkbox"
                              className="register-form__input"
                              name="no-website"
                              id="no-website"
                              checked={hasWebsite}
                              onChange={(e) => onNoWebsiteChange(e.target.checked)}
                            />
                            <span>{lang["No Website"]}</span>
                          </label>
                        </Column>
                      </Row>
                      <Row
                        extraClasses={`register-form__extra-info ${
                          hasWebsite ? "register-form__extra-info--open" : ""
                        }`}
                      >
                        <Column extraClasses="size__one-of-one">
                          <h5 className="green-text m-top__medium">
                            {lang["register_describe_institution_title"]}
                          </h5>
                          <textarea
                            name="shortdesc"
                            id="shortdesc"
                            rows="5"
                            maxLength={1000}
                            placeholder={lang["Your answer"]}
                            value={shortZooDesc}
                            onChange={(e) => setShortZooDesc(e.target.value)}
                          ></textarea>
                        </Column>
                      </Row>
                      <Row extraClasses="m-top__large">
                        <Button
                          onClick={() => gotoBackRegisterPage(1)}
                          extraClasses="button--back m-top__large m-right__small"
                        >
                          {en["Previous"]}
                        </Button>
                        <Button
                          onClick={() => gotoNextRegisterPage(3)}
                          extraClasses="m-top__large"
                        >
                          {en["Next"]}
                        </Button>
                      </Row>
                    </div>
                  </SummaryTile>
                  <SummaryTile
                    id="register-form__part3"
                    titleKey="Details of the interest"
                    extraClasses="m-top__x-large register-form__part p-right__medium p-bottom__large"
                    subTitleKey="Sections of interest (select the sections you are interested in)"
                    showButton={false}
                    activeLang={activeLang}
                  >
                    <div className="summary-tile__content m-top__x-large">
                      <Row extraClasses="m-top__medium">
                        <Column extraClasses="size__one-of-two">
                          <Checkbox
                            activeLang={activeLang}
                            extraClasses="interest-checkbox"
                            id="interest-zoo-animals"
                            labelKey="Zoo animals (all categories, mammals, birds, reptiles, fishes, etc.)"
                            onChange={(e) => {
                              setInterestSections(
                                e.target.checked
                                  ? [
                                      "interest-small-mammals",
                                      "interest-aquatic",
                                      "interest-primates",
                                      "interest-birds",
                                      "interest-reptiles",
                                      "interest-carnivores",
                                      "interest-taxidermy",
                                    ]
                                  : []
                              );
                            }}
                          />
                        </Column>
                        <Column extraClasses="size__one-of-two">
                          <Checkbox
                            activeLang={activeLang}
                            extraClasses="interest-checkbox"
                            id="interest-small-mammals"
                            labelKey="Small mammals (marmosets, kangaroos, rodents, etc.)"
                            onChange={onInterestChange}
                            checked={interestSections.includes(
                              "interest-small-mammals"
                            )}
                          />
                        </Column>
                      </Row>
                      <Row extraClasses="m-top__medium">
                        <Column extraClasses="size__one-of-two">
                          <Checkbox
                            activeLang={activeLang}
                            extraClasses="interest-checkbox"
                            id="interest-aquatic"
                            labelKey="Aquatic species (Sealions, otters, pengiuns, sharks, etc)"
                            onChange={onInterestChange}
                            checked={interestSections.includes(
                              "interest-aquatic"
                            )}
                          />
                        </Column>
                        <Column extraClasses="size__one-of-two">
                          <Checkbox
                            activeLang={activeLang}
                            extraClasses="interest-checkbox"
                            id="interest-primates"
                            labelKey="Primates"
                            onChange={onInterestChange}
                            checked={interestSections.includes(
                              "interest-primates"
                            )}
                          />
                        </Column>
                      </Row>
                      <Row extraClasses="m-top__medium">
                        <Column extraClasses="size__one-of-two">
                          <Checkbox
                            activeLang={activeLang}
                            extraClasses="interest-checkbox"
                            id="interest-birds"
                            labelKey="Birds (all species of birds)"
                            onChange={onInterestChange}
                            checked={interestSections.includes(
                              "interest-birds"
                            )}
                          />
                        </Column>
                        <Column extraClasses="size__one-of-two">
                          <Checkbox
                            activeLang={activeLang}
                            extraClasses="interest-checkbox"
                            id="interest-reptiles"
                            labelKey="Reptiles, Amphibians, Fishes, others"
                            onChange={onInterestChange}
                            checked={interestSections.includes(
                              "interest-reptiles"
                            )}
                          />
                        </Column>
                      </Row>
                      <Row extraClasses="m-top__medium">
                        <Column extraClasses="size__one-of-two">
                          <Checkbox
                            activeLang={activeLang}
                            extraClasses="interest-checkbox"
                            id="interest-carnivores"
                            labelKey="Carnivores"
                            onChange={onInterestChange}
                            checked={interestSections.includes(
                              "interest-carnivores"
                            )}
                          />
                        </Column>
                        <Column extraClasses="size__one-of-two">
                          <Checkbox
                            activeLang={activeLang}
                            extraClasses="interest-checkbox"
                            id="interest-taxidermy"
                            labelKey="Taxidermy"
                            onChange={onInterestChange}
                            checked={interestSections.includes(
                              "interest-taxidermy"
                            )}
                          />
                        </Column>
                      </Row>
                      <Row extraClasses="m-top__medium m-bottom__medium">
                        <span className="sub-title sub-title--follows-h3 browngrey-text">
                          {
                            lang[
                              "Information about available and wanted species"
                            ]
                          }
                        </span>
                      </Row>
                      <Row extraClasses="m-top__medium">
                        <Column
                          extraClasses="size__one-of-one"
                          style={{
                            backgroundColor: "#6d9c4d",
                            borderRadius: "5px",
                            padding: "10px",
                            color: "#fff",
                          }}
                        >
                          <Checkbox
                            activeLang={activeLang}
                            id="like-to-receive-surplus"
                            labelKey="register_would_like_to_receive_surplus"
                            boxColumnSize="small"
                            onChange={(e) =>
                              setReceiveSurplus(e.target.checked)
                            }
                            checked={receiveSurplus}
                          />
                        </Column>
                      </Row>
                      <Row extraClasses="m-top__large">
                        <Button
                          onClick={() => gotoBackRegisterPage(2)}
                          extraClasses="button--back m-top__large m-right__small"
                        >
                          {en["Previous"]}
                        </Button>
                        <Button
                          onClick={() => showSummary()}
                          extraClasses="m-top__large"
                        >
                          {lang["Show summary"]}
                        </Button>
                      </Row>
                    </div>
                  </SummaryTile>
                </Column>
              </Row>
            </Column>
          )}
          {showingSummary && (
            <Column extraClasses="size__two-of-three m-top__x-large">
              <div className="register-form">
                <Row>
                  <h3 className="green-text summary-tile__title m-bottom__none">
                    {lang["Check your details"]}
                  </h3>
                  <span className="line-height__large">
                    {lang["register_check_details"]}
                  </span>
                  <Row>
                    <Column extraClasses="size__two-of-twelve">
                      <select
                        name="register-form__salutation"
                        className="register-form__salutation select--creme"
                        onChange={(e) => {
                          setSalutation(e.target.value);
                        }}
                        value={salutation}
                      >
                        <option value="Mr.">Mr.</option>
                        <option value="Mrs.">Mrs.</option>
                        <option value="Ms.">Ms.</option>
                        <option value="Dr.">Dr.</option>
                        <option value="Ing.">Ing.</option>
                      </select>
                    </Column>
                    <Column extraClasses="size__five-of-twelve p-left__medium mobile-p-left__none mobile-m-top__medium">
                      <input
                        type="text"
                        className="register-form__input register-form__input--mandatory"
                        placeholder={`${lang["First Name"]}*`}
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                    </Column>
                    <Column extraClasses="column size__five-of-twelve p-left__medium mobile-p-left__none mobile-m-top__medium">
                      <input
                        type="text"
                        className="register-form__input register-form__input--mandatory"
                        placeholder={`${lang["Last Name"]}*`}
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                      />
                    </Column>
                  </Row>
                  <Row extraClasses="m-top__medium">
                    <Column extraClasses="size__one-of-two">
                      <select
                        name="register-form__country"
                        className="register-form__country select--creme"
                        value={countryId}
                        onChange={(e) => {
                          setCountryId(e.target.value);
                        }}
                      >
                        <option
                          key="empty"
                          value="empty"
                        >{`${lang["Country"]}*`}</option>
                        {renderedCountrySelect}
                      </select>
                    </Column>
                    <Column extraClasses="size__one-of-two p-left__medium mobile-p-left__none mobile-m-top__medium">
                      <input
                        type="email"
                        className="register-form__input register-form__input--mandatory"
                        placeholder={`${lang["Email address"]}*`}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Column>
                  </Row>
                  <Row extraClasses="m-top__medium">
                    <Column extraClasses="size__one-of-two">
                      <input
                        type="password"
                        className="register-form__input register-form__input--mandatory"
                        placeholder={`${lang["Create password"]}*`}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </Column>
                    <Column extraClasses="size__one-of-two p-left__medium mobile-p-left__none mobile-m-top__medium">
                      <input
                        type="password"
                        className="register-form__input register-form__input--mandatory"
                        placeholder={`${lang["Repeat Password"]}*`}
                        value={password}
                        disabled="disabled"
                      />
                    </Column>
                  </Row>
                  <Row extraClasses="m-top__medium">
                    <Column extraClasses="size__one-of-two">
                      <input
                        type="text"
                        className="register-form__input"
                        placeholder="Whatsapp"
                        value={whatsapp}
                        onChange={(e) => setWhatsapp(e.target.value)}
                      />
                    </Column>
                  </Row>
                </Row>
                <Row extraClasses="m-top__medium">
                  <Column extraClasses="size__one-of-two">
                    <select
                      name="register-form__institution"
                      className={`register-form__institution type select--creme ${
                        typeOfInstitution === "empty" ? "has-error" : ""
                      }`}
                      value={typeOfInstitution}
                      onChange={(e) => {
                        setTypeOfInstitution(e.target.value);
                      }}
                    >
                      <option value="empty">{`${lang["Type of insitution"]}*`}</option>
                      <option value="Z">
                        {lang["Zoo and public facilities"]}
                      </option>
                      <option value="PBF">
                        {lang["Private breeding farm"]}
                      </option>
                      <option value="AS">{lang["Animal supplier"]}</option>
                      <option value="ACON">
                        {lang["Animal consult and vet"]}
                      </option>
                    </select>
                  </Column>
                  <Column extraClasses="size__one-of-two p-left__medium mobile-p-left__none mobile-m-top__medium">
                    <input
                      type="text"
                      className="register-form__input register-form__input--mandatory"
                      placeholder={`${lang["Name of insitution"]}*`}
                      value={institutionName}
                      onChange={(e) => setInstitutionName(e.target.value)}
                    />
                  </Column>
                </Row>
                <Row>
                  <Column extraClasses="size__one-of-one text--centered text--small">
                    ({lang["In case you are a private person"]})
                  </Column>
                </Row>
                <Row extraClasses="m-top__medium">
                  <Column extraClasses="size__one-of-two">
                    <input
                      type="text"
                      className="register-form__input"
                      placeholder={lang["Website"]}
                      value={institutionWebsite}
                      disabled={hasWebsite}
                      onChange={(e) => setInstitutionWebsite(e.target.value)}
                    />
                  </Column>
                  <Column extraClasses="size__one-of-two p-left__medium mobile-p-left__none mobile-m-top__medium">
                    <input
                      type="text"
                      className="register-form__input"
                      placeholder={lang["Facebook page"]}
                      value={institutionFacebookPage}
                      disabled={hasWebsite}
                      onChange={(e) =>
                        setInstitutionFacebookPage(e.target.value)
                      }
                    />
                  </Column>
                </Row>
                <Row extraClasses="m-top__medium">
                  <Column extraClasses="size__one-of-one">
                    <label htmlFor="no-website">
                      <input
                        type="checkbox"
                        className="register-form__input"
                        name="no-website"
                        checked={hasWebsite}
                        onChange={(e) => onNoWebsiteChange(e.target.checked)}
                      />
                      <span>{lang["No Website"]}</span>
                    </label>
                  </Column>
                </Row>
                <Row
                  extraClasses={`register-form__extra-info ${
                    hasWebsite ? "register-form__extra-info--open" : ""
                  }`}
                >
                  <Column extraClasses="size__one-of-one">
                    <h5 className="green-text m-top__medium">
                      {lang["register_describe_institution_title"]}
                    </h5>
                    <textarea
                      name="shortdesc"
                      rows="5"
                      maxLength={1000}
                      placeholder={lang["Your answer"]}
                      value={shortZooDesc}
                      onChange={(e) => setShortZooDesc(e.target.value)}
                    ></textarea>
                  </Column>
                </Row>
                <div className="sub-title sub-title--follows-h3 browngrey-text m-top__medium">
                  {
                    lang[
                      "Sections of interest (select the sections you are interested in)"
                    ]
                  }
                </div>
                <Row extraClasses="m-top__medium">
                  <Column extraClasses="size__one-of-two">
                    <Checkbox
                      checked={interestSections.length === 7}
                      activeLang={activeLang}
                      extraClasses="interest-checkbox"
                      id="interest-zoo-animals"
                      labelKey="Zoo animals (all categories, mammals, birds, reptiles, fishes, etc.)"
                      onChange={(e) => {
                        setInterestSections(
                          e.target.checked
                            ? [
                                "interest-small-mammals",
                                "interest-aquatic",
                                "interest-primates",
                                "interest-birds",
                                "interest-reptiles",
                                "interest-carnivores",
                                "interest-taxidermy",
                              ]
                            : []
                        );
                      }}
                    />
                  </Column>
                  <Column extraClasses="size__one-of-two">
                    <Checkbox
                      checked={interestSections.includes(
                        "interest-small-mammals"
                      )}
                      activeLang={activeLang}
                      extraClasses="interest-checkbox"
                      id="interest-small-mammals"
                      labelKey="Small mammals (marmosets, kangaroos, rodents, etc.)"
                      onChange={onInterestChange}
                    />
                  </Column>
                </Row>
                <Row extraClasses="m-top__medium">
                  <Column extraClasses="size__one-of-two">
                    <Checkbox
                      checked={interestSections.includes("interest-aquatic")}
                      activeLang={activeLang}
                      extraClasses="interest-checkbox"
                      id="interest-aquatic"
                      labelKey="Aquatic species (Sealions, otters, pengiuns, sharks, etc)"
                      onChange={onInterestChange}
                    />
                  </Column>
                  <Column extraClasses="size__one-of-two">
                    <Checkbox
                      checked={interestSections.includes("interest-primates")}
                      activeLang={activeLang}
                      extraClasses="interest-checkbox"
                      id="interest-primates"
                      labelKey="Primates"
                      onChange={onInterestChange}
                    />
                  </Column>
                </Row>
                <Row extraClasses="m-top__medium">
                  <Column extraClasses="size__one-of-two">
                    <Checkbox
                      checked={interestSections.includes("interest-birds")}
                      activeLang={activeLang}
                      extraClasses="interest-checkbox"
                      id="interest-birds"
                      labelKey="Birds (all species of birds)"
                      onChange={onInterestChange}
                    />
                  </Column>
                  <Column extraClasses="size__one-of-two">
                    <Checkbox
                      checked={interestSections.includes("interest-reptiles")}
                      activeLang={activeLang}
                      extraClasses="interest-checkbox"
                      id="interest-reptiles"
                      labelKey="Reptiles, Amphibians, Fishes, others"
                      onChange={onInterestChange}
                    />
                  </Column>
                </Row>
                <Row extraClasses="m-top__medium">
                  <Column extraClasses="size__one-of-two">
                    <Checkbox
                      checked={interestSections.includes("interest-carnivores")}
                      activeLang={activeLang}
                      extraClasses="interest-checkbox"
                      id="interest-carnivores"
                      labelKey="Carnivores"
                      onChange={onInterestChange}
                    />
                  </Column>
                  <Column extraClasses="size__one-of-two">
                    <Checkbox
                      activeLang={activeLang}
                      extraClasses="interest-checkbox"
                      id="interest-taxidermy"
                      labelKey="Taxidermy"
                      onChange={onInterestChange}
                      checked={interestSections.includes("interest-taxidermy")}
                    />
                  </Column>
                </Row>
                <Row extraClasses="m-top__medium m-bottom__medium">
                  <span className="sub-title sub-title--follows-h3 browngrey-text">
                    {lang["Information about available and wanted species"]}
                  </span>
                </Row>
                <Row extraClasses="m-top__medium">
                  <Column extraClasses="size__one-of-one">
                    <Checkbox
                      checked={receiveSurplus}
                      activeLang={activeLang}
                      id="like-to-receive-surplus"
                      labelKey="register_would_like_to_receive_surplus"
                      boxColumnSize="small"
                      onChange={(e) => setReceiveSurplus(e.target.checked)}
                    />
                  </Column>
                </Row>
                <Row extraClasses="m-top__large">
                  <Button
                    onClick={() => setShowingSummary(false)}
                    extraClasses="button--back m-top__large m-right__small"
                  >
                    {lang["Previous"]}
                  </Button>
                  <Button
                    onClick={() => {
                      sendRegistrationForm();
                    }}
                    extraClasses="m-top__large"
                  >
                    {lang["Submit"]}
                  </Button>
                </Row>
              </div>
            </Column>
          )}
          <Column extraClasses="size__one-of-three p-left__medium mobile-p-right__none mobile-p-left__none">
            <div className="framed-image framed-image--xx-largeheight m-top__medium pull-up--mediumsmall pull-up--mobile-none">
              <div className="framed-image__frame">
                <div
                  className="framed-image__image"
                  style={{ backgroundImage: "url('images/koala.jpg')" }}
                ></div>
              </div>
            </div>
          </Column>
        </Row>
        <Modal extraId={"2"}>
          {submit ? (
            <>
              <h3 className="browngray-text m-top__none">
                {lang["Registered"]}
              </h3>
              <h4>{lang["approval"]}</h4>
              <h4>{lang["Check email"]}</h4>
              <Button
                onClick={() => history.push("/")}
                extraClasses="m-top__medium m-left__medium"
              >
                {lang["Home"]}
              </Button>
            </>
          ) : (
            <>
              <h3 className="browngray-text m-top__none">{lang["Sorry"]}</h3>
              <h4>{lang["Error sending"]}</h4>
              <h4>{lang["Support"]}</h4>
              <h4>{lang["Whatsapp"]}</h4>
              <h4>
                Email:{" "}
                <a href=" info@zoo-services.com" target="_blank">
                  {" "}
                  info@zoo-services.com
                </a>
              </h4>
              <Button
                onClick={() => {
                  feedModal("close");
                }}
                extraClasses="m-top__medium m-right__small"
              >
                {lang["Close"]}
              </Button>
              <Button
                onClick={() => history.push("/")}
                extraClasses="m-top__medium m-left__medium"
              >
                {lang["Home"]}
              </Button>
            </>
          )}
        </Modal>
      </Section>
      <Section
        id="be_user"
        extraClasses="creme-background m-top__xx-large p-top__x-large p-bottom__x-large mobile-p-left__large mobile-p-right__large"
      >
        <Row extraClasses="center content-width">
          <Column extraClasses="size__one-of-one text-columns--2">
            <SummaryTile
              extraClasses="keep-together"
              titleKey="Can anyone be a user"
              subTitleKey="of our databank of International Zoo Services (IZS)?"
              showButton={false}
              activeLang={activeLang}
            >
              <div className="summary-tile__content line-height__large m-top__large m-bottom__large">
                {lang["register_q_1"]}
              </div>
            </SummaryTile>
            <SummaryTile
              extraClasses="keep-together"
              titleKey="After registration"
              subTitleKey="will I automatically be a user of the databank?"
              showButton={false}
              activeLang={activeLang}
            >
              <div className="summary-tile__content line-height__large m-top__large m-bottom__large">
                {lang["register_q_2"]}
              </div>
            </SummaryTile>
            <SummaryTile
              extraClasses="keep-together"
              titleKey="Do other users get entrance"
              subTitleKey="to my details?"
              showButton={false}
              activeLang={activeLang}
            >
              <div className="summary-tile__content line-height__large m-top__large m-bottom__large">
                {lang["register_q_3"]}
              </div>
            </SummaryTile>
            <SummaryTile
              extraClasses="keep-together"
              titleKey="Why so many"
              subTitleKey="questions?"
              showButton={false}
              activeLang={activeLang}
            >
              <div className="summary-tile__content line-height__large m-top__large m-bottom__large">
                {lang["register_q_4"]}
              </div>
            </SummaryTile>
          </Column>
        </Row>
      </Section>
    </React.Fragment>
  );
};

export default Register;
